import {getJsonObjectCachedOrFetch} from "./ServiceHelpers";

export const getSubject = async (subjectKey) => {
    const subjects = await getSubjects();
    const subject = subjects.filter(d => d.key === subjectKey);
    if (subject.length > 0) {
        return subject[0];
    }
    return null;
}

export const getSubjects = async () => {
    return await getJsonObjectCachedOrFetch("api/subject", "subjects");
}

export const getProblem = async (subjectKey, themeKey, mode, params) => {
    let url = 'api/problem/?subject=' + subjectKey;
    if (themeKey) {
        url += "&theme=" + themeKey;
    }
    if (mode) {
        url += "&mode=" + mode;
    }
    for (const key of Object.keys(params)) {
        const val = params[key];
        if (val) {
            url += "&" + key + "=" + val;
        }
    }

    const response = await fetch(url);
    return await response.json();
}

export const postAnswer = async (problemId, answer) => {
    const response = await fetch("api/problemanswer/",
        {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({problemId: problemId, answer: {value: JSON.stringify(answer)}})
        });
    return await response.json();
}